var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWeatherHurricane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 20.5002C15.4965 20.814 13.9384 21 12.25 21C10.5616 21 9.00349 20.814 7.75 20.5002M18.25 16.4305C16.7841 16.9842 14.6394 17.3333 12.25 17.3333C9.86061 17.3333 7.71589 16.9842 6.25 16.4305M4.75 11.6679C6.18143 12.5598 9.00311 13.1667 12.25 13.1667C15.4969 13.1667 18.3186 12.5598 19.75 11.6679M21.25 6C21.25 7.65685 17.2206 9 12.25 9C7.27944 9 3.25 7.65685 3.25 6C3.25 4.34315 7.27944 3 12.25 3C17.2206 3 21.25 4.34315 21.25 6Z",
    stroke: "#02222B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeatherHurricane);
export default __webpack_public_path__ + "static/media/icon_weather_hurricane.fe9e984e3fc486f129c0ef714ea18954.svg";
export { ForwardRef as ReactComponent };